import React from "react";
import { Link } from "react-router-dom";
import { PageSettings } from "./../../config/page-settings.js";
import SidebarProfile from "./sidebar-profile.jsx";
import SidebarNav from "./sidebar-nav.jsx";

class Sidebar extends React.Component {
  render () {
    return (
      <PageSettings.Consumer>
        {({ toggleSidebarMinify, toggleMobileSidebar, pageSidebarTransparent }) => (
          <React.Fragment>
            <div id="sidebar" className={"sidebar " + (pageSidebarTransparent ? "sidebar-transparent" : "")}>
              <div className="_overflow-scroll _height-full">
                <SidebarProfile />
                <SidebarNav />
                <Link to="/" className="sidebar-minify-btn" onClick={toggleSidebarMinify}>
                  <i className="fa fa-angle-double-left"></i>
                </Link>
              </div>
            </div>
            <div className="sidebar-bg"></div>
            <div className="sidebar-mobile-dismiss" onClick={toggleMobileSidebar}></div>
          </React.Fragment>
        )}
      </PageSettings.Consumer>
    );
  }
}

export default Sidebar;
